import React, { useState, useEffect, useRef, forwardRef } from 'react';

const ResumeTaskModal = forwardRef(({ ResumeTaskDisplay, CancelResumeTask, HandleResumeTask }, ref) => {

    const [loading, setLoading] = useState(false);

    return (
        <div style={{display:'flex', flexDirection:'column'}} className='resume-task-container' ref={ref}>
            <div style={{margin:'10px', height:'100%', alignContent:'center'}}>
                <strong>{ResumeTaskDisplay}</strong>
            </div>
            <div style={{display: 'flex', flexDirection: 'column',marginTop: 'auto',alignItems: 'center',padding: '10px'}}>
                <button className='button' disabled={loading} style={{marginBottom:'10px'}} onClick={() => {setLoading(true); HandleResumeTask();}}>Resume Task</button>
                <button className='button' disabled={loading} onClick={() => CancelResumeTask()}>New Task</button>
            </div>
        </div>
    )
});

export default ResumeTaskModal;